<template>
  <div>
    <img :src="require('@/assets/first-canadian_breakdown.png')" width="100" height="32" />
    <h2 class="title">
      {{ product.payload.product }}
    </h2>
    <img
      :src="require('@/assets/first-canadian-tire-protection-stock.png')"
      width="375"
      height="211"
      class="center full-width"
    />
    <h3>{{ product.payload.message[0] }}</h3>
    <p>{{ product.payload.message[1] }}</p>
    <p>{{ product.payload.message[2] }}</p>
    <h3>{{ product.payload.message[3] }}</h3>
    <ul>
      <li>{{ product.payload.message[4] }}</li>
      <li>{{ product.payload.message[5] }}</li>
      <li>{{ product.payload.message[6] }}</li>
      <li>{{ product.payload.message[7] }}</li>
    </ul>
    <h3>{{ product.payload.message[8] }}</h3>
    <ul>
      <li>{{ product.payload.message[9] }}</li>
      <li>{{ product.payload.message[10] }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'MechanicalBreakdown',
  props: {
    product: {
      validator: prop => typeof prop === 'object' || prop === undefined,
      required: true,
    },
  },
};
</script>

<style scoped>
.title {
  font-size: 22px;
  font-weight: bold;
  color: rgb(25, 34, 43);
}
h3 {
  font-size: 16px;
  font-weight: bold;
  color: rgb(75, 88, 99);
}
p {
  font-size: 16px;
  color: rgb(75, 88, 99);
  padding-bottom: 10px;
}
li {
  font-size: 16px;
  color: rgb(75, 88, 99);
  padding-bottom: 15px;
}
.center {
  display: block;
  width: 100%;
  height: auto;
}
.title {
  margin-bottom: 16px;
}
@media only screen and (max-width: 575px) {
  .full-width {
    width: 100vw;
    position: relative;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
  }
}
@media only screen and (min-width: 576px) {
  .title {
    font-size: 28px;
    margin-bottom: 24px;
    font-weight: bold;
    color: rgb(25, 34, 43);
  }
  .center {
    margin-left: auto;
    margin-right: auto;
    display: block;
    height: 320px;
  }
}
</style>
